import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Drop-in replacement for react-router's <Link> that appends a trailing slash
// to internal string paths, so links match the site's canonical (trailing-slash)
// URLs. This prevents Googlebot from following no-slash internal links and
// hitting a 301 → slash redirect (which showed up in Search Console).
//
// Safe by design: only rewrites string `to` values that start with "/", aren't
// the root, aren't a file (have no extension), and preserves #hash / ?query.
export function withTrailingSlash(to) {
  if (typeof to !== 'string') return to;        // object `to` — leave as-is
  if (!to.startsWith('/')) return to;           // external / relative
  if (to === '/') return to;                    // root
  const i = to.search(/[?#]/);
  const path = i === -1 ? to : to.slice(0, i);
  const rest = i === -1 ? '' : to.slice(i);
  if (path.endsWith('/')) return to;            // already slashed
  const lastSeg = path.split('/').pop();
  if (lastSeg.includes('.')) return to;         // looks like a file (e.g. .pdf)
  return path + '/' + rest;
}

const SlashLink = React.forwardRef(function SlashLink({ to, ...props }, ref) {
  return <RouterLink ref={ref} to={withTrailingSlash(to)} {...props} />;
});

export default SlashLink;
